var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit03Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49999 10.8326H11.375M1.625 10.8326H2.53204C2.79702 10.8326 2.9295 10.8326 3.05418 10.8027C3.16472 10.7762 3.27039 10.7324 3.36732 10.673C3.47665 10.606 3.57033 10.5123 3.7577 10.325L10.5625 3.52014C11.0112 3.07141 11.0112 2.34387 10.5625 1.89514C10.1138 1.44641 9.38625 1.44641 8.93751 1.89514L2.13268 8.69996C1.94532 8.88733 1.85164 8.98101 1.78464 9.09033C1.72524 9.18726 1.68147 9.29294 1.65493 9.40348C1.625 9.52815 1.625 9.66064 1.625 9.92561V10.8326Z",
    stroke: "#424242",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit03Icon);
export default __webpack_public_path__ + "static/media/edit-03_icon.3cde2935eb07121391713d24a5260f5a.svg";
export { ForwardRef as ReactComponent };